/**
 * Default (default.com) Pixel / Forms SDK.
 *
 * In-app demo form id and pixel public key come from env (`data-default-form-id` /
 * `form_id`).
 */
export const DEFAULT_PIXEL_SDK_SCRIPT_URL = 'https://pixel.default.com/sdk.js';
export const DEFAULT_PIXEL_SDK_READY_EVENT = 'default-pixel-sdk-ready';

/** Public pixel key from Default Signals (client-safe). */
export const DEFAULT_PIXEL_PUBLIC_KEY = process.env.NEXT_PUBLIC_DEFAULT_PIXEL_PUBLIC_KEY;

/** In-app demo / lead form (`data-default-form-id` / `form_id`). */
export const DEFAULT_PIXEL_IN_APP_DEMO_FORM_ID = process.env.NEXT_PUBLIC_DEFAULT_PIXEL_IN_APP_DEMO_FORM_ID;

/** DOM `id` on the in-app demo `<form>` (Default pixel HTML form id). */
export const DEFAULT_PIXEL_IN_APP_DEMO_FORM_HTML_ID = process.env.NEXT_PUBLIC_DEFAULT_PIXEL_IN_APP_DEMO_FORM_HTML_ID;

export const isDefaultPixelSdkConfigured = (): boolean =>
  Boolean(DEFAULT_PIXEL_PUBLIC_KEY && DEFAULT_PIXEL_IN_APP_DEMO_FORM_ID && DEFAULT_PIXEL_IN_APP_DEMO_FORM_HTML_ID);

export const DEMO_FORM_NOT_CONFIGURED_ERROR =
  'Demo form is not configured yet. Set NEXT_PUBLIC_DEFAULT_PIXEL_PUBLIC_KEY, NEXT_PUBLIC_DEFAULT_PIXEL_IN_APP_DEMO_FORM_ID, and NEXT_PUBLIC_DEFAULT_PIXEL_IN_APP_DEMO_FORM_HTML_ID.';

export const DEMO_FORM_SUBMIT_ERROR_MESSAGE = 'Unable to submit the demo request. Please try again or contact support.';
